(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["guest-details"] && !Shopify.designMode) return;
  try {
    (function () {
    var MIN_GUESTS = 1;
    var MAX_GUESTS = 20;

    function initGuestDetails() {
      var container = document.querySelector('.guest-details');
      if (!container) return;

      var entriesRoot = container.querySelector('[data-guest-entries]');
      var addButton = container.querySelector('[data-add-guest]');
      var template = container.querySelector('[data-guest-entry-template]');
      if (!entriesRoot || !addButton || !template) return;

      var maileonId = container.getAttribute('data-maileon-id');

      var productForm = Array.prototype.slice
        .call(document.querySelectorAll('form[action*="/cart/add"]'))
        .find(function (form) {
          return !form.classList.contains('installment');
        });

      if (productForm && !productForm.contains(container)) {
        var submitButton = productForm.querySelector('[type="submit"], [name="add"]');
        if (submitButton && submitButton.parentNode === productForm) {
          productForm.insertBefore(container, submitButton);
        } else {
          productForm.appendChild(container);
        }
      }

      if (productForm && maileonId) {
        var maileonInput = productForm.querySelector('input[name="attributes[Maileon ID]"]');
        if (!maileonInput) {
          maileonInput = document.createElement('input');
          maileonInput.type = 'hidden';
          maileonInput.name = 'attributes[Maileon ID]';
          productForm.appendChild(maileonInput);
        }
        maileonInput.value = maileonId;
      }

      function getEntries() {
        return Array.prototype.slice.call(entriesRoot.querySelectorAll('[data-guest-entry]'));
      }

      function refreshRemoveButtons() {
        var all = getEntries();
        var disable = all.length <= MIN_GUESTS;
        all.forEach(function (entry) {
          var removeButton = entry.querySelector('[data-remove-guest]');
          if (removeButton) removeButton.disabled = disable;
        });
      }

      function reindex() {
        getEntries().forEach(function (entry, i) {
          var index = i + 1;
          var nameLabel = entry.querySelector('[data-guest-name-label]');
          var emailLabel = entry.querySelector('[data-guest-email-label]');
          var nameInput = entry.querySelector('[data-guest-name-input]');
          var emailInput = entry.querySelector('[data-guest-email-input]');
          var removeButton = entry.querySelector('[data-remove-guest]');
          var removeLabel = entry.querySelector('[data-guest-remove-label]');

          if (nameLabel) nameLabel.textContent = nameLabel.getAttribute('data-i18n').replace('%n', index);
          if (emailLabel) emailLabel.textContent = emailLabel.getAttribute('data-i18n').replace('%n', index);
          if (nameInput) nameInput.name = 'properties[Guest ' + index + ' Name]';
          if (emailInput) emailInput.name = 'properties[Guest ' + index + ' Email]';
          if (removeLabel && removeButton) {
            removeLabel.textContent = removeButton.getAttribute('data-i18n').replace('%n', index);
          }
        });
      }

      function attachRemoveListener(entry) {
        var removeButton = entry.querySelector('[data-remove-guest]');
        if (!removeButton) return;
        removeButton.addEventListener('click', function () {
          entry.remove();
          reindex();
          refreshRemoveButtons();
        });
      }

      function createEntry() {
        var fragment = template.content.cloneNode(true);
        var entry = fragment.querySelector('[data-guest-entry]');
        attachRemoveListener(entry);
        return entry;
      }

      if (getEntries().length === 0) {
        entriesRoot.appendChild(createEntry());
      } else {
        getEntries().forEach(attachRemoveListener);
      }
      reindex();
      refreshRemoveButtons();

      addButton.addEventListener('click', function () {
        if (getEntries().length >= MAX_GUESTS) return;

        var entry = createEntry();
        entriesRoot.appendChild(entry);
        reindex();
        refreshRemoveButtons();

        var nameInput = entry.querySelector('[data-guest-name-input]');
        if (nameInput) nameInput.focus();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGuestDetails);
    } else {
      initGuestDetails();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
